<template>
  <component
    :is="tagName"
    :role="role"
    tabindex="-1"
    class="oct-menu-list"
  >
    <slot />
  </component>
</template>

<script>
export default {
  name: 'OctMenuList',
  props: {
    /** Tag name */
    tagName: {
      type: String,
      default: 'ul'
    },
    /** Native role attribute */
    role: {
      type: [String, null],
      default: 'menu'
    },
  },
}
</script>

<style scoped lang="scss">
@import "../theme/variables";
@import "../grid/variables";
@import "../typography/variables";
@import "../typography/mixins";

.oct-menu-list {
  margin: 0;
  display: flex;
  flex-direction: column;
}
</style>
